import {Injectable} from '@angular/core';
import {countryConfig} from 'src/country-config/country-config';

@Injectable({
  providedIn: 'root',
})
export class SetCountryService {
  country = countryConfig.cctld.toUpperCase();

  changeUrl(endpoint: string): string {
    const setCountry = endpoint.replace('{country}', this.country);
    return setCountry;
  }
}
